import { Grid } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

import iconPlace from '../../../../../../assets/img/routelist-stops/icon-place.svg';
import iconTime from '../../../../../../assets/img/routelist-stops/icon-time.svg';
import iconExternalID from '../../../../../../assets/img/stop-details/icon-externalD.svg';
import iconLabel from '../../../../../../assets/img/stop-details/icon-name.svg';
import {
  default as iconMultiselect,
  default as iconSelect,
} from '../../../../../../assets/img/stop-details/icon-option.svg';
import {
  default as iconBoolean,
  default as iconNumber,
  default as iconString,
} from '../../../../../../assets/img/stop-details/icon-others.svg';
import iconReferencePerson from '../../../../../../assets/img/stop-details/icon-p.reference.svg';
import iconRequirements from '../../../../../../assets/img/stop-details/icon-require.svg';
import iconVolume from '../../../../../../assets/img/stop-details/icon-volume.svg';
import iconWeight from '../../../../../../assets/img/stop-details/icon-weight.svg';
import { ProjectDriversFieldTypes } from '../../../../../../domain/stops/Stop';

import EmailIcon from '../../../../../../assets/svg/EmailIcon';
import PhoneIcon from '../../../../../../assets/svg/PhoneIcon';
import WebIcon from '../../../../../../assets/svg/WebIcon';

interface StopDetailsFieldProps {
  id: string;
  typeItem: ProjectDriversFieldTypes;
}

export const StopDetailsImageByType = ({ typeItem, id }: StopDetailsFieldProps) => {
  const styleImg = { height: `15px`, width: `15px`, paddingRight: `5px`, color: RoutalPalette.secondary00 };
  const renderImageByType = () => {
    switch (id) {
      case `label`:
        return <img src={iconLabel} alt="label" style={styleImg} />;
      case `external_id`:
        return <img src={iconExternalID} alt="external_id" style={styleImg} />;
      case `reference_person`:
        return <img src={iconReferencePerson} alt="reference_person" style={styleImg} />;
      case `phone`:
        return <PhoneIcon alt="Phone" style={styleImg} />;
      case `location_details`:
      case `location`:
        return <img src={iconPlace} alt="Phone" style={styleImg} />;
      case `email`:
        return <EmailIcon alt="Email" style={styleImg} />;
      case `weight`:
        return <img src={iconWeight} alt="weight" style={styleImg} />;
      case `volume`:
        return <img src={iconVolume} alt="volume" style={styleImg} />;
      case `website`:
        return <WebIcon alt="URL" style={styleImg} />;
      case `requirements`:
        return <img src={iconRequirements} alt="requirements" style={styleImg} />;
      default:
        break;
    }
    switch (typeItem) {
      case `string`:
        return <img src={iconString} alt="String" style={styleImg} />;
      case `number`:
        return <img src={iconNumber} alt="Number" style={styleImg} />;
      case `time`:
      case `time_window`:
        return <img src={iconTime} alt="Time" style={styleImg} />;
      case `multiselect`:
        return <img src={iconMultiselect} alt="Multiselect" style={styleImg} />;
      case `select`:
        return <img src={iconSelect} alt="Select" style={styleImg} />;
      case `boolean`:
        return <img src={iconBoolean} alt="Booolean" style={styleImg} />;
      default:
        return null;
    }
  };

  return <Grid container>{renderImageByType()}</Grid>;
};
